var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8019 9.20001H4.6013C3.7176 9.20001 3.00122 9.91636 3.00122 10.8V16.4C3.00122 17.2837 3.7176 18 4.6013 18H15.8019C16.6856 18 17.402 17.2837 17.402 16.4V10.8C17.402 9.91636 16.6856 9.20001 15.8019 9.20001Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.202 9.19998V5.99998C6.202 4.93912 6.62345 3.9217 7.37363 3.17156C8.12382 2.42141 9.14129 1.99998 10.2022 1.99998C11.2631 1.99998 12.2806 2.42141 13.0308 3.17156C13.781 3.9217 14.2024 4.93912 14.2024 5.99998V9.19998",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.c87d03a59c7e1c235d06ecdcf4775872.svg";
export { ForwardRef as ReactComponent };